import { render, staticRenderFns } from "./quickMitsumoriList.vue?vue&type=template&id=36e035c6&"
import script from "./quickMitsumoriList.vue?vue&type=script&lang=ts&"
export * from "./quickMitsumoriList.vue?vue&type=script&lang=ts&"
import style0 from "./quickMitsumoriList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports